import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import ConfirmSubmitProposal from '../common/ConfirmSubmitProposal';

function SubmitProposal({
  fullName,
  updateUserSettingsUrl,
  editUrl,
  formUrl,
  submitToOpenMarketplace,
  csrfToken,
  animation,
  disabled,
  referralProps,
}) {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onSubmit = (value) => (
    setIsSubmitted(value)
  );

  if (isSubmitted) {
    if (submitToOpenMarketplace) {
      return (
        <div className="headline">
          <h2>Proposal sent to hiring manager!</h2>
          <p>
            The hiring manager is reviewing your proposal.
            If accepted, Clora will coordinate the interview.
          </p>
        </div>
      );
    }
    return (
      <div className="headline">
        <h2>Proposal submitted!</h2>
        <p>Clora will review and send your proposal to the employer for consideration.</p>
      </div>
    );
  }

  return (
    <Fragment>
      {submitToOpenMarketplace
        && (
        <div className="headline">
          <h2>Submit your proposal.</h2>
          <p>
            Your proposal will be sent directly to the hiring manager.
            {' '}
            <br />
            If accepted, Clora will coordinate the interview.
            Check your proposal&#39;s status under My Applications.
          </p>
        </div>
        )}
      {!submitToOpenMarketplace
        && (
        <div className="headline">
          <h2>Submit your proposal.</h2>
          <p>Clora will review and send your proposal to the employer for consideration.</p>
        </div>
        )}
      <div className="cta g-row g-flex-align-center">
        <a href={editUrl} className="mr-30">Edit Proposal</a>
        <ConfirmSubmitProposal
          fullName={fullName}
          updateUserSettingsUrl={updateUserSettingsUrl}
          formUrl={formUrl}
          submitToOpenMarketplace={submitToOpenMarketplace}
          csrfToken={csrfToken}
          animation={animation}
          disabled={disabled}
          referralProps={referralProps}
          onSubmitCallback={onSubmit}
        />
      </div>
    </Fragment>
  );
}

SubmitProposal.propTypes = {
  editUrl: PropTypes.string.isRequired,
  fullName: PropTypes.string,
  updateUserSettingsUrl: PropTypes.string.isRequired,
  formUrl: PropTypes.string.isRequired,
  submitToOpenMarketplace: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  referralProps: PropTypes.shape({}),
};

SubmitProposal.defaultProps = {
  fullName: null,
  submitToOpenMarketplace: false,
  animation: false,
  disabled: false,
  referralProps: {},
};

export default SubmitProposal;
